<template>
    <div id="app">
        <div class="loading" v-if="isLoading">
            <img src="https://www.3dreal.com/assets/3dreal-loading.gif" />
        </div>
        <div class="bf-logo">
            <img src="~@/assets/image/3dreal-logo@2x.png" />
        </div>
        <div id="panorama"></div>
        <modal
                :title="title"
                :is-show="show"
                :show-ok="false"
                :show-footer="false"
                transition="fadeDown"
                @close="show = false"
        >
            <div style="height:100%">
                <iframe style="width: 100%;height:100%" :src="iframeSrc" />
            </div>
        </modal>
        <music-con />
    </div>
</template>
<script>
    import musicCon from "@/components/music-con";
    export default {
        name: "App",
        components: {
            musicCon
        },
        data() {
            return {
                show: false,
                title: "",
                iframeSrc: "",
                isLoading: true
            };
        },
        mounted() {
            // eslint-disable-next-line no-undef
            let viewer = pannellum.viewer("panorama", {
                //Pannellum支持四种处理全景图片的方式：equirectangular,partial,cubic,multi-resolution
                allow_user_interactions: false,
                hotSpotDebug:false,
                firstScene: "circle", //首次加载那个图片
                sceneFadeDuration: 1000, //全景图场景切换时的持续时间
                autoLoad: true, //自动加载
                panorama: "https://pannellum.org/images/tocopilla.jpg",
                showControls: false, //是否显示控制按钮，默认true；
                autoRotate: -2, //是否自动旋转，在加载之后，全景图会水平旋转显示，负数为往右边旋转，整数为往左边旋转，值为数字类型；
                //场景，值为对象，其属性名代表着场景的id（sceneId），属性值为viewer的配置参数，其参数会覆盖默认（上述中的default对象）设置的参数；
                pitch: -29,
                yaw: -151,
                hfov: 100.0,
                type: "multires",
                multiRes: {
                    basePath: "./image/output",
                    "path": "/%l/%s%y_%x",
                    "fallbackPath": "/fallback/%s",
                    "extension": "jpg",
                    "tileResolution": 512,
                    "maxLevel": 3,
                    "cubeResolution": 1704
                },
                hotSpots: [
                    //热点，以全景为坐标系的固定点，可以设置链接跳转和点击事件，也可以跳转到不同的场景，该属性的值为对象
                    {
                        pitch: -6.247544441174431,
                        yaw: -26.26722603461446,
                        type: "info",
                        cssClass: "shou1",
                        text: "伊斯兰女长裙\nJPY¥888",
                        clickHandlerFunc: () => {
                            this.iframeSrc =
                                "https://www.3dreal.com/share/eyJpZCI6IjAyODJjYTUyLWExYWYtNDUyZC04NWI0LTQ1ZWIxZDdiMDA2NyIsInR5cGUiOiJDT0xMT0NBVElPTiIsImhhc1Bhc3N3b3JkIjpmYWxzZX0";
                            this.show = true;
                            this.title = "伊斯兰女长裙\n";
                        }
                    },
                    {
                        pitch: -1.590283410975527,
                        yaw: -120.26722603461446,
                        type: "info",
                        cssClass: "shou1",
                        text: "时尚吊带裙JPY¥888",
                        clickHandlerFunc: () => {
                            this.iframeSrc ="http://3dexample.befash.cn/?scene_id=94&category_id=194&from=message&isappinstalled=0"
                            this.show = true;
                            this.title = "时尚吊带裙";
                        }
                    }
                ]
            });
            window.addEventListener("load", () => {
                setTimeout(() => {
                    this.isLoading = false;
                    var ele = document.querySelectorAll('.shou1')
                    console.log(ele);
                }, 1000);
            });
            console.log(viewer);
        },
        methods: {
        }
    };
</script>
<style>
    .pnlm-ui .pnlm-about-msg {
        display: none !important;
    }

    .pnlm-ui .pnlm-orientation-button {
        display: none !important;
    }
    .pnlm-lmsg {
        display: none;
    }
</style>
<style lang="less">
    body {
        margin: 0;
        padding: 0;
    }
    #app {
        .bf-logo {
            position: absolute;
            top: 0;
            right: 0;
            z-index: 1;
        }
    }
    #panorama {
        height: 100vh;
    }
    .shou1 {
        background-image: url("../../assets/image/10.png");
        width: 50px;
        height: 50px;
        background-size: 50px 300px;
        animation: show1 0.3s infinite step-start;
    }
    @keyframes show1 {
        0% {
            background-position: 0 0;
        }
        25% {
            background-position: 0 -250px;
        }
        50% {
            background-position: 0 -150px;
        }
        75% {
            background-position: 0 -150px;
        }
        100% {
            background-position: 0 0;
        }
    }
    .arrow {
        background-image: url("../../assets/image/arrow.png");
        width: 64px;
        height: 64px;
        background-size: 64px 1600px;
        animation: arrow 0.8s infinite step-start;
    }
    @keyframes arrow {
        0% {
            margin-top: 0;
        }
        25% {
            margin-top: -5px;
        }
        50% {
            margin-top: -10px;
        }
        75% {
            margin-top: -15px;
        }
        100% {
            margin-top: -20px;
        }
    }
    .loading {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: -webkit-box;
        display: flex;
        -webkit-box-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        align-items: center;
        z-index: 100;
        background-color: #fff;
        img {
            width: 22%;
            height: auto;
        }
    }
</style>
